import {
  ADD_AUTOMATION,
  ADD_AUTOMATION_FAIL,
  ADD_AUTOMATION_SUCCESS,
  SAVE_AUTOMATION,
  SAVE_AUTOMATION_FAIL,
  SAVE_AUTOMATION_SUCCESS,
  DELETE_AUTOMATION,
  DELETE_AUTOMATION_FAIL,
  DELETE_AUTOMATION_SUCCESS,
  FETCH_AUTOMATION_CUSTOMERS,
  FETCH_AUTOMATION_CUSTOMERS_FAIL,
  FETCH_AUTOMATION_CUSTOMERS_SUCCESS,
  FETCH_AUTOMATION_LIST,
  FETCH_AUTOMATION_LIST_FAIL,
  FETCH_AUTOMATION_LIST_SUCCESS,
  SET_VALUE_CHANGED,
  UPDATE_AUTOMATION,
  UPDATE_AUTOMATION_FAIL,
  UPDATE_AUTOMATION_FLAG,
  UPDATE_AUTOMATION_FLAG_FAIL,
  UPDATE_AUTOMATION_FLAG_SUCCESS,
  UPDATE_AUTOMATION_NAME,
  UPDATE_AUTOMATION_NAME_FAIL,
  UPDATE_AUTOMATION_NAME_SUCCESS,
  UPDATE_AUTOMATION_SUCCESS,
  UPDATE_VISIBLE_AUTOMATION,
  SET_AUTOMATION_PRIORITY,
  SET_AUTOMATION_PRIORITY_FAIL,
  SET_AUTOMATION_PRIORITY_SUCCESS,
  RESET_AUTOMATION
} from '../../actions/cm/automation';

export const initialState = {
  isLoading: false,
  isLoadingDetails: false,
  hasError: false,
  hasErrorDetails: false,
  priorityError: false,
  list: [],
  errorMessage: '',
  visibleAutomationId: '',
  isValueChanged: false,
  showAddSuccess: false,
  showSaveSuccess: false,
  showDeleteSuccess: false,
  showUpdateSuccess: false,
  showUpdateFlagSuccess: false,
  typologyActions: [],
  customersList: [],
  showPrioritySuccess: false,
  addAutomationError: false,
  savedId: null,
  priorityList: [],
  automationData: {}
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_AUTOMATION_LIST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        hasErrorDetails: false,
        priorityError: false,
        addAutomationError: false,
        isValueChanged: false,
        showSaveSuccess: false,
        showDeleteSuccess: false,
        showUpdateSuccess: false,
        showUpdateFlagSuccess: false,
        showPrioritySuccess: false,
        showAddSuccess: false
      };
    case FETCH_AUTOMATION_LIST_SUCCESS:
      return {
        ...state,
        list: payload.automationList,
        defaultConfig: payload.defaultConfig,
        typologyActions: payload.typologyActions,
        isLoading: false,
        isLoadingDetails: false
      };
    case ADD_AUTOMATION:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        hasErrorDetails: false,
        automationData: payload.automationData
      };
    case FETCH_AUTOMATION_CUSTOMERS:
    case UPDATE_AUTOMATION:
    case SAVE_AUTOMATION:
      return {
        ...state,
        isLoadingDetails: true,
        hasError: false,
        hasErrorDetails: false
      };
    case ADD_AUTOMATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showAddSuccess: true,
        addAutomationError: false
      };
    case FETCH_AUTOMATION_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isLoadingDetails: false,
        // showSaveSuccess: true,
        customersList: payload.customersList //need to verify
      };
    case UPDATE_AUTOMATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showSaveSuccess: true
      };
    case SAVE_AUTOMATION_SUCCESS:
      return {
        ...state,
        isLoadingDetails: false,
        showSaveSuccess: true,
        savedId: payload.id
      };
    case ADD_AUTOMATION_FAIL:
      return {
        ...state,
        isLoading: false,
        addAutomationError: true,
        errorMessage: payload.message
      };
    case FETCH_AUTOMATION_CUSTOMERS_FAIL:
    case UPDATE_AUTOMATION_FAIL:
      return {
        ...state,
        isLoadingDetails: false,
        hasErrorDetails: true,
        errorMessage: payload.message
      };
    case UPDATE_AUTOMATION_FLAG:
    case UPDATE_AUTOMATION_NAME:
    case DELETE_AUTOMATION:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case UPDATE_AUTOMATION_FLAG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showUpdateFlagSuccess: true
      };
    case UPDATE_AUTOMATION_NAME_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showUpdateSuccess: true
      };
    case DELETE_AUTOMATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showDeleteSuccess: true
      };
    case FETCH_AUTOMATION_LIST_FAIL:
    case UPDATE_AUTOMATION_FLAG_FAIL:
    case UPDATE_AUTOMATION_NAME_FAIL:
    case DELETE_AUTOMATION_FAIL:
    case SAVE_AUTOMATION_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case UPDATE_VISIBLE_AUTOMATION:
      return {
        ...state,
        visibleAutomationId: payload.visibleAutomationId,
        hasErrorDetails: false
      };
    case SET_VALUE_CHANGED:
      return {
        ...state,
        isValueChanged: payload.isValueChanged
      };
    case SET_AUTOMATION_PRIORITY:
      return {
        ...state,
        isLoading: true,
        priorityList: payload
      };
    case SET_AUTOMATION_PRIORITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        priorityError: false,
        showPrioritySuccess: true
      };
    case SET_AUTOMATION_PRIORITY_FAIL:
      return {
        ...state,
        isLoading: false,
        priorityError: true,
        errorMessage: payload.message
      };
    case RESET_AUTOMATION:
      return {
        ...state,
        priorityError: false,
        addAutomationError: false
      };
    default:
      return state;
  }
}
